import { Component, Input } from '@angular/core';
import { CustomersType } from '../../enum/customersType';

@Component({
  selector: 'app-customers-childs-details-table',
  templateUrl: './customers-childs-details-table.component.html',
  styleUrl: './customers-childs-details-table.component.scss'
})
export class CustomersChildsDetailsTableComponent {

  @Input() data:any

  customersType = CustomersType
}
